import { Mic } from "lucide-react";
import { useShallow } from "zustand/react/shallow";

import { buttonVariants } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";
import { cn } from "@/lib/utils";

export function SelectMicrophone() {
  const vidyoSDK = useVidyoStore((state) => state.vidyoSDK);

  const microphones = useVidyoStore((state) => state.microphone.available);
  const selectedMicrophone = useVidyoStore(
    useShallow((state) => ({
      id: state.microphone.selected?.id,
      name: state.microphone.selected?.name,
    })),
  );
  const setPreferredMicrophone = useVidyoStore(
    (state) => state.microphone.setPreferred,
  );

  const handleSelectMicrophone = async (microphoneId: string) => {
    const microphone = microphones.find((m) => m.id === microphoneId);
    if (microphone) {
      await vidyoSDK?.SelectLocalMicrophone({
        localMicrophone: microphone,
      });
      setPreferredMicrophone(microphone);
    }
  };

  return (
    <Select
      value={selectedMicrophone?.id}
      onValueChange={handleSelectMicrophone}
    >
      <SelectTrigger
        className={cn(buttonVariants({ variant: "ghost" }), "justify-normal")}
        disabled={microphones.length === 0}
      >
        <Mic className="mr-2 h-4 w-4 flex-shrink-0" />
        <span className="inline-block truncate">
          {microphones.length === 0
            ? "No microphone(s) available"
            : (selectedMicrophone?.name ?? "Select Microphone...")}
        </span>
      </SelectTrigger>
      <SelectContent>
        {microphones.map((microphone) => (
          <SelectItem key={microphone.id} value={microphone.id}>
            {microphone.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
